import { Routes, Route } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import { lazy, Suspense } from 'react'

import { RootLayout } from './layouts/RootLayout'
import { AdminLayout } from './layouts/AdminLayout'
import { LoadingSpinner } from './components/ui/loading-spinner'
import { ThemeProvider } from './components/ui/theme-provider'
import { AuthProvider, RequireAuth } from './features/auth/context/AuthContext'

// Lazy load page components
const HomePage = lazy(() => import('./pages/home/HomePage'))
const AdminPage = lazy(() => import('./pages/admin/AdminPage'))
const MatchPage = lazy(() => import('./pages/admin/match/MatchPage'))
const CoachMatchPage = lazy(() => import('./pages/admin/match/CoachMatchPage'))
const ScreensPage = lazy(() => import('./pages/screens/ScreensPage'))
const ScreenPage = lazy(() => import('./pages/screens/ScreenPage'))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      refetchOnWindowFocus: false
    }
  }
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="dark" storageKey="padlo-live-theme">
        <AuthProvider>
          <Suspense fallback={
            <div className="flex min-h-screen-updated items-center justify-center">
              <LoadingSpinner />
            </div>
          }>
            <Routes>
              <Route element={<RootLayout />}>
                <Route index element={<HomePage />} />
                <Route path="screens">
                  <Route index element={<ScreensPage />} />
                  <Route path=":id" element={<ScreenPage />} />
                </Route>
                <Route path="admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                  <Route index element={<AdminPage />} />
                  <Route path="m">
                    <Route path=":id/coach" element={<CoachMatchPage />} />
                    <Route path=":id" element={<MatchPage />} />
                  </Route>
                </Route>
              </Route>
            </Routes>
          </Suspense>
          <Toaster position="top-right" />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

